import * as React from "react";
import * as R from "ramda";
import {Col, Grid, Row, Glyphicon} from "react-bootstrap";
import {connect} from "react-redux";
import logo from "../../assets/img/logo-sura.png";
import Menu from "./inicio/componentes/Menu";
import Router from "./inicio/componentes/Router";
import {consultarMenu, consultarOficinas} from "./inicio/modulos/inicioActions";
import {REQUEST} from "./config/ajax-wrapper";
import {DotLoader} from "react-spinners";
import {Mensaje} from "./dominio/general/componentes/Mensaje";
import HoraActual from "./dominio/general/componentes/HoraActual";

class App extends React.Component<any, any> {

    componentDidMount() {
        this.props.dispatch(consultarMenu());

        if (!this.props.oficinas || this.props.oficinas.length === 0) {
            this.props.dispatch(consultarOficinas());
        }
    }

    componentDidUpdate() {
        const seusForm = document.forms[0];
        if (seusForm && seusForm.action.includes("seus")) {
            seusForm.submit();
        }
    }

    public render() {
        const {estado, seusForm, codigo} = this.props;
        switch (estado) {
            case REQUEST.PENDING:
                return (
                    <Grid>
                        <Row>
                            <Col smOffset={4} sm={4}>
                                <DotLoader size={120}/><label>Estamos verificando tu información</label>
                            </Col>
                        </Row>
                    </Grid>
                );
            case REQUEST.SUCCESS:
                return this.mainContent();
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error verificando la App"}/>;
            case REQUEST.FORBIDDEN:
                if (codigo === 401) {
                    return this.renderSeusForm(seusForm);
                } else {
                    return (
                        <Mensaje type={"danger"}
                                 mensaje={"Su usuario no posee permisos para abrir esta aplicación"}/>
                    );
                }

            default:
                return <DotLoader size={120}>Cargando</DotLoader>;
        }
    }

    mainContent = () => {
        return (
            <div>
                <div>
                    <div className={"header-dark"}>
                        <Grid>
                            <Row>
                                <Col sm={6} className={"title-white"}>
                                    Gestor de Afiliaciones ARL
                                </Col>
                                <Col sm={6}>
                                    <span className={"login pull-right"}>
                                        <Glyphicon glyph={"log-out"}/> 
                                        &nbsp; <a href={this.props.logoutURL} className={"logout-link"}>Cerrar Sesión</a>
                                    </span>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                    <div className={"header"}>
                        <Grid>
                            <Row>
                                <Col sm={2}>
                                    <div>
                                        <Menu/>
                                        <div className={"vhr"}/>
                                    </div>
                                </Col>
                                <Col sm={10}>
                                    <Col sm={6}>
                                        <img src={logo} alt="Gestor de Afiliaciones ARL"/>
                                    </Col>
                                    <Col sm={6}>
                                        <div className={"login"}>
                                            <Row>
                                                <Col>
                                                    Bienvenido
                                                    <strong className={"user-name"}>
                                                        {" " + this.props.nombre.split("+").join(" ")}
                                                    </strong>
                                                    &nbsp; <Glyphicon glyph={"user"}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    Último ingreso: {this.props.lastAccess}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <HoraActual/>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </div>
                <Grid>
                    <Row>
                        <Col className="main line-form">
                            <Router/>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    };

    renderSeusForm = (seusForm) => {
        return <div dangerouslySetInnerHTML={{__html: seusForm}}/>;
    }

}

export default connect((store: any) => {
    const {router} = store;
    return {
        estado: R.pathOr([], ["inicio", "estado"])(store),
        seusForm: R.pathOr([], ["inicio", "seusForm"])(store),
        codigo: R.pathOr([], ["inicio", "codigo"])(store),
        nombre: R.pathOr(" ", ["inicio", "nombreLogin"])(store),
        lastAccess: R.pathOr("", ["inicio", "lastAccess"])(store),
        fullName: R.pathOr("", ["inicio", "fullName"])(store),
        logoutURL: R.pathOr("", ["inicio", "logoutURL"])(store),
        oficinas: R.pathOr([], ["inicio", "oficinas"])(store),
        router
    };
})(App);


// WEBPACK FOOTER //
// ./src/co/sura/App.tsx